import React, { useEffect, useRef, useState } from "react";
import { JdsButton } from "../../../components/jds/JdsButton";
import { CloseIcon } from "../../../components/jds/icons";
import "../../../components/jds/jds.css";
import "./vinculacao.css";
import ScopeSelector from "../components/ScopeSelector";
import { removedScopes, scopeLabel } from "../utils/scopeCatalog";

const TITLE_ID = "vinculacao-scopes-modal-title";

// Escolha dos produtos de um cliente, na criação e na edição. Montado só
// enquanto aberto, então a seleção nasce de `initialScopes` a cada abertura.
//
// Na edição, a retirada de produto é avisada antes de salvar: o cliente perde o
// acesso na requisição seguinte, sem período de graça.
//
// Enquanto salva, o modal trava inteiro (fechar e marcar): a seleção na tela
// tem que ser a que foi enviada, e fechar no meio esconderia o erro.
//
// Diálogo JDS (mesmo padrão do UserDetailsConfirmModal): precisa ser renderizado
// dentro de .jds-scope. Fecha por Esc e por clique no fundo, como o Modal
// anterior, e só quando não está salvando.
export default function ClientScopesModal({
  title,
  description,
  initialScopes,
  confirmLabel,
  saving,
  errorMessage,
  onConfirm,
  onHide,
}) {
  const [selectedScopes, setSelectedScopes] = useState(initialScopes);
  const scopesBeingRemoved = removedScopes(initialScopes, selectedScopes);

  const dialogRef = useRef(null);
  useEffect(() => {
    dialogRef.current?.focus();
  }, []);

  const closeUnlessSaving = () => {
    if (!saving) onHide();
  };

  return (
    <div
      className="vinculacao-modal"
      onMouseDown={event => {
        if (event.target === event.currentTarget) closeUnlessSaving();
      }}
    >
      <div
        ref={dialogRef}
        className="vinculacao-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={TITLE_ID}
        tabIndex={-1}
        onKeyDown={event => {
          if (event.key === "Escape") closeUnlessSaving();
        }}
      >
        <div className="vinculacao-modal__header">
          <h2 id={TITLE_ID} className="jds-title-md">
            {title}
          </h2>
          {!saving && (
            <JdsButton
              variant="ghost"
              color="neutral"
              size="sm"
              iconOnly
              aria-label="Fechar"
              title="Fechar"
              onClick={onHide}
            >
              <CloseIcon />
            </JdsButton>
          )}
        </div>

        <div className="vinculacao-modal__description">{description}</div>

        {errorMessage && (
          <div className="vinculacao-alert vinculacao-alert--warning" role="alert">
            {errorMessage}
          </div>
        )}

        <fieldset className="vinculacao-modal__fieldset" disabled={saving}>
          <ScopeSelector
            selectedScopes={selectedScopes}
            onChange={setSelectedScopes}
          />
        </fieldset>

        {scopesBeingRemoved.length > 0 && (
          <div
            className="vinculacao-alert vinculacao-alert--error vinculacao-modal__removal"
            role="alert"
          >
            Ao salvar, o cliente <strong>perde o acesso imediatamente</strong> a:{" "}
            {scopesBeingRemoved.map(scopeLabel).join(", ")}.
          </div>
        )}

        <div className="vinculacao-modal__actions">
          <JdsButton
            variant="outlined"
            color="neutral"
            onClick={onHide}
            disabled={saving}
          >
            Cancelar
          </JdsButton>
          <JdsButton
            color={scopesBeingRemoved.length > 0 ? "error" : "brand"}
            onClick={() => onConfirm(selectedScopes)}
            disabled={saving}
          >
            {confirmLabel}
          </JdsButton>
        </div>
      </div>
    </div>
  );
}
